import { useSelector, useDispatch } from 'react-redux';
import selectors from 'store/selectors';

import CustomDialog from 'components/CustomDialog/customDialog';
import { setDialog } from 'store/actions/dialogActions';
import { useState } from 'react';

import { OperationsSubmit } from './style';
import CTypography from 'components/CTypography';
import CustomButton from 'components/Button/CustomButton';
import actions from 'store/actions';
import DIALOGS from 'utils/dialogIds';
import CustomDialogHeader from 'components/CustomDialog/DialogHeader/dialogHeader.cmp';

const ConfirmEditSubmission = () => {
  const dispatch = useDispatch();
  const dialogState = useSelector(selectors.getDialogState);

  const data = dialogState?.[DIALOGS.CONFIRM_EDIT_SUBMISSION]?.data;

  const { onDiscard, onChecklistSubmitCb } = data;

  const handleClose = () => {
    dispatch(
      setDialog({
        open: false,
        dialogId: DIALOGS.CONFIRM_EDIT_SUBMISSION,
      }),
    );
  };

  const handleSubmit = async () => {
    handleClose();
    onChecklistSubmitCb && onChecklistSubmitCb();
    return;
  };
  const handleDiscard = () => {
    handleClose();
    onDiscard();
  };
  return (
    <CustomDialog
      header={
        <CustomDialogHeader onClose={handleClose}>
          <CTypography fontSize={'20px'} fontWeight={700}>
            Save Changes
          </CTypography>
        </CustomDialogHeader>
      }
      hideActions={true}
      dialogProps={{
        maxWidth: 'xs',
        open: dialogState?.[DIALOGS.CONFIRM_EDIT_SUBMISSION]?.open,
      }}
    >
      <OperationsSubmit>
        <CTypography className="description">
          You have unsaved changes. Would you like to discard or save them?
        </CTypography>
        <div className="actions">
          <CustomButton variant="text" disableElevation onClick={handleClose}>
            Cancel
          </CustomButton>
          <CustomButton
            variant="outlined"
            disableElevation
            onClick={handleDiscard}
            sx={{ marginLeft: 'auto' }}
          >
            Discard
          </CustomButton>
          <CustomButton variant="contained" onClick={handleSubmit}>
            Save Changes
          </CustomButton>
        </div>
      </OperationsSubmit>
    </CustomDialog>
  );
};

export default ConfirmEditSubmission;
